import styled from "styled-components";
import { Headline, Paragraph } from "../../../components/styled/Text";

const InfoBlockContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
`;

const InfoBlockHeadline = styled(Headline)`
  font-size: 34px;
`;

const InfoBlock = () => {
  return (
    <InfoBlockContainer>
      <InfoBlockHeadline textAlign="center">
        Transaction Confirmation
      </InfoBlockHeadline>
      <Paragraph textAlign="center">
        Please indicate your new tokens address. So you could start sending your
        new token to the snapshot addresses.
      </Paragraph>
    </InfoBlockContainer>
  );
};

export default InfoBlock;
